import { Wrapper, Title, Description } from './CrashCourseHeaderStyles';

interface Props {
  className?: string;
}

const CrashCourseHeader = ({ className }: Props) => (
  <Wrapper className={className}>
    <Title
      data-cy='crashCourseTitle'
      as='h1'
      $fontFamily='graphikCond'
      $size={{ default: 'large', mdMax: 'level1' }}
    >
      Crypto Crash Course
    </Title>
    <Description data-cy='crashCourseDescription'>
      Learn all of the most important blockchain and cryptocurrency terms and jargon here.
    </Description>
  </Wrapper>
);

export default CrashCourseHeader;
